import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { PershingLocaleService } from '../services/pershing-locale.service';

@Pipe({
    name: 'pershingDecimalFormatingPipe'
})

export class PershingDecimalFormatPipe implements PipeTransform {

    private decimalPipe: DecimalPipe;
    public readonly zeroDecimals = '1.0-0';
    public readonly twoDecimals = '1.2-2';
    public readonly fourDecimals = '1.4-4';
    public readonly fiveDecimals = '1.5-5';
    public readonly sixDecimals = '1.6-6';
    public readonly nineDecimals = '1.9-9';
    public readonly twelveDecimals = '1.12-12';

    constructor(private localeService: PershingLocaleService) {
       // this.decimalPipe = new DecimalPipe('en');
    }

    transform(value: any, format: any, localeValue?: any) {
		let locale: any = localeValue;
        if (!localeValue) {
            locale = this.localeService.getCurrentLocale();
        }
        if (!this.decimalPipe) {
            this.decimalPipe = new DecimalPipe(locale);
        }
        if (value || value === 0) {
            switch (format) {
                case this.zeroDecimals:
                    return this.decimalPipe.transform(value, format, locale);
                case this.twoDecimals:
                    return this.decimalPipe.transform(value, format, locale);
                case this.fourDecimals:
                    return this.decimalPipe.transform(value, format, locale);
                case this.fiveDecimals:
                    return this.decimalPipe.transform(value, format, locale);
                case this.sixDecimals:
                    return this.decimalPipe.transform(value, format, locale);
                case this.nineDecimals:
                    return this.decimalPipe.transform(value, format, locale);
                case this.twelveDecimals:
                    return this.decimalPipe.transform(value, format, locale);
                default:
                    if (format && format === '') {
                        return this.decimalPipe.transform(value, format, locale);
                    } else {
                        return value;
                    }
            }
        // if null
        } else {
            return '';
        }
    }
}
